
{{element._get('text')}}{{element._get('mandatoryIndication')? "*":""}}
